<template>
  <div class="vp">
    <div class="vp__item" v-for="(item, index) in vp" :key="`${_uid}${index}`">
      <b-row :style="`flex-direction: ${invert ? 'row-reverse' : 'row'};`">
        <b-col lg="4" xl="6">
          <div class="vp__right">
            <img :src="item.vp_image" />
          </div>
        </b-col>
        <b-col lg="8" xl="6">
          <div class="vp__left">
            <div
              v-for="(content, content_index) in item.vp_content"
              :key="`${_uid}${content_index}`"
            >
              <div class="vp__icon">
                <vb-icon
                  v-if="content.vp_icon"
                  :name="content.vp_icon"
                  :color="'var(--secondary)'"
                />
              </div>
              <div>
                <div class="h3 vp__title" v-html="content.vp_title"></div>
                <div class="vp__text">
                  <span v-html="content.vp_text" />
                  <customer-support-action
                    v-if="content.vp_support_action"
                    :cta_id="content.vp_cta_id || 'value-proposition'"
                  >
                    <strong>{{ content.vp_support_action }}</strong>
                  </customer-support-action>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "value-proposition",
  props: {
    vp: {
      type: Array,
      default: () => [],
    },
    invert: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.vp {
  background: $white;
  border-radius: $border-radius-lg * 2;
  overflow: hidden;

  a {
    color: $vb-body-color;
    &:hover {
      //color: $link-color;
      text-decoration: underline;
    }
  }

  &__left {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    & > div {
      display: flex;
      padding: $grid-gutter-width * 2 $grid-gutter-width * 2
        $grid-gutter-width * 2 $grid-gutter-width;

      &:not(:last-child) {
        margin-bottom: $grid-gutter-width * 2;
      }

      @include media-breakpoint-up(lg) {
        padding: 0 $grid-gutter-width * 2 0 0;
      }
    }
  }

  &__right {
    position: relative;
    min-height: 240px;
    img {
      position: absolute;
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: top center;
    }
    @include media-breakpoint-up(md) {
      min-height: 500px;
    }
  }

  &__icon {
    margin: 0 1rem;
  }

  &__title {
    @include font-primary-semibold;
    margin-bottom: 1rem;
  }
}
</style>
